import { useContext, useRef } from 'react';

import { RoutesContext } from '@confluence/route-manager';

export const useWhiteboardQueryParamState = (
	contentId: string,
	param: string,
	clearParam = true,
) => {
	const { getQueryParams, setQueryParams } = useContext(RoutesContext);
	const paramValue = getQueryParams()?.[param] as string | undefined;

	const whiteboardParam = useRef(paramValue);
	const prevContentId = useRef(contentId);

	if (prevContentId.current !== contentId) {
		whiteboardParam.current = undefined;
	}

	if (paramValue) {
		whiteboardParam.current = paramValue;
	}

	if (paramValue && clearParam) {
		setQueryParams({ [param]: undefined }, true);
	}

	prevContentId.current = contentId;

	return whiteboardParam.current;
};
